import { ExhibitionDateFormatter } from 'models/ExhibitionDateFormatter';
import ExhibitionDates from 'models/ExhibitionDates';
import { useTranslations, useLocale } from 'next-intl';
import PropTypes from 'prop-types';

const ExhibitionDisplayDates = ({ exhibitionDates }) => {
	const locale = useLocale();
	const t = useTranslations();
	return (
		<>
			{new ExhibitionDateFormatter(
				new ExhibitionDates(exhibitionDates),
				locale,
			).translate(t)}
		</>
	);
};

ExhibitionDisplayDates.propTypes = {
	exhibitionDates: PropTypes.shape({
		startDate: PropTypes.string.isRequired,
		endDate: PropTypes.string,
		startDateOverride: PropTypes.string,
		endDateOverride: PropTypes.string,
	}),
};

export default ExhibitionDisplayDates;
